import { Component } from '@angular/core';

@Component({
  selector: 'via-sku-data',
  templateUrl: './sku-data.component.html',
  styleUrls: ['./sku-data.component.scss']
})
export class SkuDataComponent {
}
